import React from 'react';
import { motion } from 'framer-motion';

/**
 * LongIntro — long-form 2-4 paragraph SEO-rich introduction.
 * Props: { eyebrow?, heading, paragraphs: string[], aside?: ReactNode, isRTL }
 */
const LongIntro = ({ eyebrow, heading, paragraphs = [], aside, isRTL = false }) => (
  <section className="py-16 lg:py-20" data-testid="long-intro">
    <div className="max-w-[1240px] mx-auto px-6">
      <div className={`grid ${aside ? 'lg:grid-cols-3' : 'lg:grid-cols-1'} gap-10`}>
        <motion.div initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className={`${aside ? 'lg:col-span-2' : 'max-w-[820px] mx-auto'} ${isRTL ? 'text-right' : ''}`}>
          {eyebrow && <p className="varo-eyebrow varo-text-flame mb-3">{eyebrow}</p>}
          <h2 className="varo-display text-3xl lg:text-4xl mb-6 leading-tight">{heading}</h2>
          <div className="space-y-5 text-ink-700 text-base lg:text-lg leading-[1.8]">
            {paragraphs.map((p, i) => (
              <p key={i} data-testid={`intro-p-${i}`}>{p}</p>
            ))}
          </div>
        </motion.div>
        {aside && (
          <aside className="lg:col-span-1">{aside}</aside>
        )}
      </div>
    </div>
  </section>
);

export default LongIntro;
